import type { Lang } from "./seo";

/** /download and /en/download: indexable landing page, shared by the prerender and the runtime head. */
export const DOWNLOAD_PATH_FR = "/download";
export const DOWNLOAD_PATH_EN = "/en/download";

export function downloadSeo(lang: Lang) {
  const isFr = lang === "fr";
  return {
    path: isFr ? DOWNLOAD_PATH_FR : DOWNLOAD_PATH_EN,
    title: isFr
      ? "Télécharger ReFound — App de reçus gratuite pour iPhone et Android"
      : "Download ReFound — Free receipt app for iPhone and Android",
    description: isFr
      ? "Téléchargez ReFound gratuitement sur l'App Store ou Google Play. Numérisez vos reçus, retrouvez vos produits et suivez vos retours et garanties au Canada."
      : "Download ReFound for free on the App Store or Google Play. Scan your receipts, identify your products and track returns and warranties in Canada.",
  };
}
